import { render, staticRenderFns } from "./Approves.vue?vue&type=template&id=0b83c324&"
import script from "./Approves.vue?vue&type=script&lang=js&"
export * from "./Approves.vue?vue&type=script&lang=js&"
import style0 from "./Approves.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports